import * as d3 from 'd3'

export default {
  methods: {

    
    reflash(crt, y) {
      d3.select('#CRT_ID').text(crt.id)
      d3.select('#CRT_COUNT').text(crt.count)
      d3.select('#CRT_MODE').text(crt.mode)
    },

    
  }
}